// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.line---B9ZjX {
  width: inherit;
  height: 55px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #dbdbdb;
}
.text---yezSu {
  margin-top: -1px;
  height: inherit;
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #262626;
  font-family: 'Segoe UI', Roboto, Helvetica, Arial;
  font-size: 13px;
  color: #262626;
  letter-spacing: 0.7px;
  text-align: center;
  line-height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/separator.less"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EAEA,6BAAA;AAAF;AAGA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EAEA,iDAAA;EACA,eAAA;EAEA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AAJF","sourcesContent":[".line {\n  width: inherit;\n  height: 55px;\n  display: flex;\n  justify-content: center;\n\n  border-top: 1px solid #dbdbdb;\n}\n\n.text {\n  margin-top: -1px;\n  height: inherit;\n  width: 65px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid #262626;\n\n  font-family: 'Segoe UI', Roboto, Helvetica, Arial;\n  font-size: 13px;\n\n  color: #262626;\n  letter-spacing: 0.7px;\n  text-align: center;\n  line-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"line": `line---B9ZjX`,
	"text": `text---yezSu`
};
export default ___CSS_LOADER_EXPORT___;
